import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Select, RadioInput } from './Form'
import MultiComplete from './MultiComplete'
import { getGroupItemsAndSetFieldOptions, setFieldAttributes } from '../WizardActions'
import deepEqual from 'deep-equal'

const STATE_NAME = process.env.STATE_NAME

class ServerOptions extends Component {
  constructor() {
    super()
    this.state = { options: [{ value: '0', label: 'Loading...' }] }
  }
  componentDidMount() {
    this.setState({ options: [{ value: '0', label: 'Loading...' }] })
    const shouldForceFetch = !this.props.options.length || this.resolveUnmountedOverrideChanges()
    this.getOptions({ forceFetch: shouldForceFetch })
  }
  componentDidUpdate = (prevProps) => {
    const {
      fields,
      optionsSrcOverride,
      subOptionsSrcOverride,
      fieldId,
      optionsSrcOverrideValue,
      subOptionsSrcOverrideValue,
    } = this.props
    const dependsOnAnOverrideValue =
      optionsSrcOverride ||
      subOptionsSrcOverride ||
      optionsSrcOverrideValue ||
      subOptionsSrcOverrideValue
    if (dependsOnAnOverrideValue) {
      let optionsSrcChanged = false
      let subOptionsSrcChanged = false
      if (optionsSrcOverride && !optionsSrcOverrideValue) {
        let prevField = prevProps.fields[optionsSrcOverride].value
        let currentField = fields[optionsSrcOverride].value
        optionsSrcChanged = !deepEqual(prevField, currentField)
      }
      if (subOptionsSrcOverride && !subOptionsSrcOverrideValue) {
        let prevField = prevProps.fields[subOptionsSrcOverride].value
        let currentField = fields[subOptionsSrcOverride].value
        subOptionsSrcChanged = !deepEqual(prevField, currentField)
      }
      if (optionsSrcOverrideValue) {
        optionsSrcChanged = prevProps.optionsSrcOverrideValue !== optionsSrcOverrideValue
      }
      if (subOptionsSrcOverrideValue) {
        subOptionsSrcChanged = prevProps.subOptionsSrcOverrideValue !== subOptionsSrcOverrideValue
      }
      if (optionsSrcChanged || subOptionsSrcChanged) {
        this.setState({ options: [{ value: '0', label: 'Loading...' }] })
        this.resetValue()
        if (this.props.onOptionsFetchStarted) this.props.onOptionsFetchStarted()
        this.props.getGroupItemsAndSetFieldOptions(
          fieldId,
          this.getPassedField(),
          this.props.onOptionsFetched
        )
      }
    }
  }
  resolveUnmountedOverrideChanges = () => {
    const {
      fields,
      optionsSrcOverride,
      subOptionsSrcOverride,
      lastSeenOptionsSrcOverride,
      lastSeenSubOptionsSrcOverride,
    } = this.props
    let overrideChangedWhileUnmounted = false
    if (optionsSrcOverride && lastSeenOptionsSrcOverride) {
      overrideChangedWhileUnmounted = !deepEqual(
        lastSeenOptionsSrcOverride,
        fields[optionsSrcOverride].value
      )
    }
    if (
      subOptionsSrcOverride &&
      overrideChangedWhileUnmounted === false &&
      lastSeenSubOptionsSrcOverride
    ) {
      overrideChangedWhileUnmounted = !deepEqual(
        lastSeenSubOptionsSrcOverride,
        fields[subOptionsSrcOverride].value
      )
    }
    if (overrideChangedWhileUnmounted) {
      this.resetValue()
    }
    return overrideChangedWhileUnmounted
  }
  resetValue = () => {
    this.props.setFieldAttributes({
      fieldId: this.props.fieldId,
      payload: { value: this.props.controlType === 'ServerMultiComplete' ? 
        [] : 
        // For selects the default value is actually '0', not ''. '0' is also what Tecuity Reports considers the default "empty" value.
        this.props.controlType === 'select' ? '0' : '' 
      },
    })
  }
  getPassedField = () => {
    return this.props.passFieldToOptionsHandler
      ? {
          optionsSrc: this.props.optionsSrcOverrideValue || this.props.optionsSrc,
          subOptionsSrc: this.props.subOptionsSrcOverrideValue || this.props.subOptionsSrc,
          includeAllOption: this.props.includeAllOption || undefined,
        }
      : undefined
  }
  getOptions = ({ forceFetch }) => {
    if (!this.props.optionsFetched || forceFetch) {
      this.props.getGroupItemsAndSetFieldOptions(
        this.props.fieldId,
        this.getPassedField(),
        this.props.onOptionsFetched
      )
    }
  }
  formatLabel = (str) => {
    str = str.toLowerCase().split(' ')
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].split('')
      if (str[i].length > 0) {
        str[i][0] = str[i][0].toUpperCase()
        str[i] = str[i].join('')
      }
    }
    return str.join(' ').replace('_', ' ').replace('-', ' ')
  }
  setFieldValue = (value, e, payload) => {
    this.props.onChange(value, e, {
      ...payload,
      selectedOptionLabel: this.state.options.find((option) => (option.value === value).label),
    })
  }
  handleFieldBlur = (value) => {
    this.props.onBlur(value)
  }
  render() {
    const {
      value,
      required,
      name,
      controlType,
      width,
      isValid,
      disabled,
      validityClass,
      options = [],
      placeholder,
      optionGroups,
      fieldId,
      tabIndex,
      excludeCurrentState,
      label,
      ...restProps
    } = this.props
    let computedOptions = options
    let foundUpperCaseValue = null
    if (controlType === 'select') {
      if (required) {
        computedOptions = [
          { value: '', label: '[Select an option]' },
          ...(excludeCurrentState
            ? options.filter((item) => item.value.toLowerCase() !== STATE_NAME.toLowerCase())
            : options),
        ]
      } else {
        computedOptions = [
          { value: '0', label: placeholder },
          ...(excludeCurrentState
            ? options.filter((item) => item.value.toLowerCase() !== STATE_NAME.toLowerCase())
            : options),
        ]
      }
      if (!options.find((item) => item.value === value)) {
        if (
          options.find(
            (item) => item.value.toString().toUpperCase() === value.toString().toUpperCase()
          )
        ) {
          foundUpperCaseValue = value.toString().toUpperCase()
        }
      }
    }
    return (
      <div>
        {controlType === 'select' ? (
          <Select
            onChange={this.setFieldValue}
            onBlur={this.handleFieldBlur}
            fieldId={fieldId}
            options={computedOptions}
            value={foundUpperCaseValue ? foundUpperCaseValue : value}
            required={required}
            width={width}
            validityClass={validityClass}
            isValid={isValid}
            disabled={disabled}
            optionGroups={optionGroups}
            tabIndex={tabIndex}
          />
        ) : controlType === 'ServerMultiComplete' ? (
          <MultiComplete
            onChange={this.setFieldValue}
            onBlur={this.handleFieldBlur}
            fieldId={fieldId}
            name={name}
            options={computedOptions}
            value={value}
            required={required}
            width={width}
            validityClass={validityClass}
            isValid={isValid}
            disabled={disabled}
            tabIndex={tabIndex}
            placeholder={placeholder}
            {...restProps}
          />
        ) : (
          <RadioInput
            label={label}
            ownsLabel
            onChange={this.setFieldValue}
            onBlur={this.handleFieldBlur}
            fieldId={fieldId}
            name={name}
            options={computedOptions}
            value={value}
            required={required}
            width={width}
            validityClass={validityClass}
            isValid={isValid}
            disabled={disabled}
            tabIndex={tabIndex}
            description={this.props.description}
          />
        )}
      </div>
    )
  }
}
export default connect(
  (state) => ({
    fields: state.wizard.wizard.fields,
  }),
  { getGroupItemsAndSetFieldOptions, setFieldAttributes }
)(ServerOptions)
